import api from "../../domain/api";
import {
  GET_APPLICANTS,
  ADD_APPLICANT,
  EDIT_APPLICANT,
  GET_APPLICANT,
  RESET_APPLICANT,
  GET_ALL_APPLICANTS,
  ERROR_APPLICANT,
} from "../types/applicant_type";
import * as qs from "qs";

import { handleError } from "../../shared/handleError";
import { setAlert } from "./alert";
export const addApplicant = (formData) => async (dispatch, getState) => {
  try {
    const { data } = await api.post(`/applicants`, formData);
    dispatch({
      type: ADD_APPLICANT,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getApplicants =
  ({ pageNumber = "" }) =>
  async (dispatch) => {
    try {
      dispatch({
        type: RESET_APPLICANT,
      });
      const queryParams = qs.parse(window.location.search.replace("?", ""));
      const query = qs.stringify(queryParams, {
        encodeValuesOnly: true, // prettify url
      });
      const { data } = await api.get(
        `/applicants?&pageNumber=${pageNumber}&${query}`
      );

      dispatch({
        type: GET_APPLICANTS,
        payload: data,
      });
    } catch (error) {
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };
export const getApplicant = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_APPLICANT,
    });
    const { data } = await api.get(`/applicants/${id}`);

    dispatch({
      type: GET_APPLICANT,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const editApplicant = (id, formData) => async (dispatch) => {
  try {
    const { data } = await api.put(`/applicants/${id}`, formData);
    dispatch({
      type: EDIT_APPLICANT,
      payload: data,
    });
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const deleteApplicant = (id) => async (dispatch) => {
  try {
    const { data } = await api.delete(`/applicants/${id}`);
    dispatch(setAlert("Applicant Deleted Successfully", "success"));
  } catch (error) {
    dispatch(handleErrorLocal(error));
    dispatch(handleError(error));
  }
};
export const getAllApplicants =
  ({ term, value }) =>
  async (dispatch) => {
    try {
      const { data } = await api.get(
        `/applicants/all?term=${term}&value=${value}`
      );

      dispatch({
        type: GET_ALL_APPLICANTS,
        payload: data,
      });
    } catch (error) {
      dispatch(handleErrorLocal(error));
      dispatch(handleError(error));
    }
  };

export const handleErrorLocal = () => async (dispatch) => {
  dispatch({ type: ERROR_APPLICANT });
};
